import masterCard from "../../../assets/images/Cards-icons/mastercard.svg";
import cirrus from "../../../assets/images/Cards-icons/cirrus.svg";
import maestro from "../../../assets/images/Cards-icons/maestro.svg";
import visaCard from "../../../assets/images/Cards-icons/visa.svg";
import visaPlus from "../../../assets/images/Cards-icons/visa-plus.svg";
import interlink from "../../../assets/images/Cards-icons/interlink.svg";
import discover from "../../../assets/images/Cards-icons/discover.svg";
import americanExpress from "../../../assets/images/Cards-icons/amex.svg";
import unionPay from "../../../assets/images/Cards-icons/unionpay.svg";
import blackhawak from "../../../assets/images/Cards-icons/blackhawak.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import { I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { toTitleCase } from "../../../Utils/stringUtls";
import {
  atm_networks as atmNetworksList,
  cardInfo,
  cardTechnology,
  binInformation,
  binType,
  cardOptions,
} from "../CardNetworkAndBinInfo/stringUtils";
import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { formatReviewDate } from "./reviewSummaryUtils";

const CardNetworkAndBinInfo = ({ data }) => {
  if (!data) return <DataNotFound />;
  const {
    cn_n_networks,
    cn_atm_networks,
    cn_n_networks_other,
    cn_atm_networks_other,
    cn_bin_Information,
    cn_business_id,
    cn_ica,
    cn_bin_no,
    cn_settlement_currency,
    cn_bin_type,
    cn_bin_quantity,
    cn_bin_quantity_other,
    cn_target_date,
    cn_insurance_region,
    cn_additional_card_information,
    cn_additional_card_information_other,
    cn_chip_profile,
    cn_card_option,
    cn_card_number,
    cn_card_information,
    cn_card_information_other,
  } = data?.["2_0"] ?? {};

  const networks = [
    { label: "Master Card ®", value: 0, icon: masterCard },
    { label: "Cirrus ®", value: 1, icon: cirrus },
    { label: "Maestro ®", value: 2, icon: maestro },
    { label: "VISA ® Card", value: 3, icon: visaCard },
    { label: "Interlink ® Card", value: 4, icon: visaPlus },
    { label: "PLUS ® Card", value: 5, icon: interlink },
    { label: "Discover ®", value: 6, icon: discover },
    { label: "American Express ®", value: 7, icon: americanExpress },
    { label: "UnionPay ®", value: 8, icon: unionPay },
    { label: "Blackhawk Network ®", value: 9, icon: blackhawak },
    { label: "Other", value: 10, icon: cardPlaceholder },
  ];

  const cardTechnologyValue =
    [
      ...cardTechnology
        .filter(
          (tech) =>
            cn_additional_card_information?.includes(tech.value) &&
            tech.value !== 4,
        )
        .map((tech) => tech.label),
      ...(cn_additional_card_information_other?.length
        ? [cn_additional_card_information_other]
        : []),
    ].join(", ") || "-";

  const cardInfoValue =
    [
      ...cardInfo
        .filter(
          (tech) =>
            cn_card_information?.includes(tech.value) && tech.value !== 4,
        )
        .map((tech) => tech.label),
      ...(cn_card_information_other?.length ? [cn_card_information_other] : []),
    ].join(", ") || "-";

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Card Network & BIN" className='font-bold mt-0'/>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text pt-4">Card Networks</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {cn_n_networks?.length
              ? networks
                  .filter((network) => cn_n_networks?.includes(network.value))
                  .map((network, index, arr) => (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={network.value}
                    >
                      <I2cIcon
                        src={network.icon}
                        style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                      />
                      <span>
                        {network.value === 10
                          ? toTitleCase(cn_n_networks_other)
                          : network.label}
                        {index < arr.length - 1 ? "," : ""}
                      </span>
                    </span>
                  ))
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text">ATM Networks</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {cn_atm_networks?.length
              ? atmNetworksList
                  .filter((network) =>
                    cn_atm_networks?.includes(network.value),
                  )
                  .map((network, index, arr) => (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={network.value}
                    >
                      <I2cIcon
                        src={network.icon}
                        style={{ fontSize: "var(--i2c-spacing-8-5)" }}
                      />
                      <span>
                        {network.value === 5
                          ? toTitleCase(cn_atm_networks_other)
                          : network.label}
                        {index < arr.length - 1 ? "," : ""}
                      </span>
                    </span>
                  ))
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md" className="review-summary-sub-heading font-bold">
          <div className="font-semi-bold">Bin Information</div>
        </div>

        <ReviewAttribute
          label="BIN Information"
          value={binInformation[cn_bin_Information]?.label ?? "-"}
        />
        {cn_bin_Information === 1 ? (
          <ReviewAttribute
            label="ICA"
            value={cn_ica?.length ? toTitleCase(cn_ica) : "-"}
          />
        ) : (
          <ReviewAttribute
            label="Business ID"
            value={cn_business_id?.length ? toTitleCase(cn_business_id) : "-"}
          />
        )}
        <ReviewAttribute
          label="BIN(s)"
          value={cn_bin_no?.length ? toTitleCase(cn_bin_no) : "-"}
        />
        <ReviewAttribute
          label="Settlement Currency"
          value={
            cn_settlement_currency?.length
              ? toTitleCase(cn_settlement_currency)
              : "-"
          }
        />
        <ReviewAttribute
          label="Type of BIN"
          value={binType[cn_bin_type]?.label ?? "-"}
        />
        <ReviewAttribute
          label="Number of Sub-BIN(s)"
          value={
            cn_bin_quantity_other > 0
              ? String(cn_bin_quantity_other)
              : cn_bin_quantity?.length
                ? cn_bin_quantity
                : "-"
          }
        />
        <ReviewAttribute
          label="Target Install/Migration Date"
          value={cn_target_date?.length ? formatReviewDate(cn_target_date) : "-"}
        />
        <ReviewAttribute
          label="Issuance Country/Region"
          value={cn_insurance_region?.length ? cn_insurance_region : "-"}
        />
        <ReviewAttribute label="Card Technology" value={cardTechnologyValue} />
        <ReviewAttribute
          label="Chip Profile"
          value={cn_chip_profile?.length ? toTitleCase(cn_chip_profile) : "-"}
        />
        <ReviewAttribute
          label="Card Options"
          value={
            cn_card_option?.length
              ? (cardOptions.find((opt) => opt.value === cn_card_option)
                  ?.label ?? "-")
              : "-"
          }
        />
        {cn_card_number?.length ? (
          <ReviewAttribute label="Card Number" value={cn_card_number} />
        ) : null}
        <ReviewAttribute label="Card Information" value={cardInfoValue} />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default CardNetworkAndBinInfo;
